import Section from '../Section';
import { createClickableSection } from '../modules/sectionLink';

export default class VideoHero extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    createClickableSection(this.element);
  }
}
